import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {};
type Response = {
  lastPayoutAmount: number;
  totalPayoutAmount: number;
  ongoingRentalsCount: number;
  upcomingRentalsCount: number;
  totalCarsCount: number;
  totalActiveCarsCount: number;
};

export const useDashboardMetrics = createQuery<Response, Variables, AxiosError>(
  {
    queryKey: ['dashboard/metrics'],
    fetcher: () => {
      return client.get(`v2/internal/partners/dashboard`).then((response) => {
        return response.data.data;
      });
    },
  }
);
